import React from 'react';
import PropTypes from 'prop-types';
import style from './FeatureArticle.module.scss';

const FeatureArticle = props => {
    const { title, description } = props;
    return (
        <>
            <section className={style.el}>
                <div className={[style.container, 'container'].join(' ')}>
                    <h1 className={style.headline}>{title}</h1>
                    <p className={style.desc}>{description}</p>
                </div>
            </section>
        </>
    );
};

FeatureArticle.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    item: PropTypes.object,
    popup: PropTypes.bool,
};
export default FeatureArticle;

FeatureArticle.defaultProps = {};
